import { useEffect, useRef } from "react";
import echo from "../lib/echo";

/**
 * Subscribe to project channels to forward notification payloads into the app
 * Useful on pages that list multiple projects (e.g., ProjectList)
 *
 * @param {Array<number|string>} projectIds
 */
export function useNotificationsRealtime(projectIds) {
  const subscribed = useRef(new Set());

  useEffect(() => {
    if (!Array.isArray(projectIds) || projectIds.length === 0) return;

    projectIds.forEach((pid) => {
      const channelName = `project.${pid}`;
      if (subscribed.current.has(channelName)) return;

      const channel = echo
        .channel(channelName)
        .listen(".question.added", (event) => {
          if (event?.notification) {
            try {
              window.dispatchEvent(
                new CustomEvent("app:new-notification", { detail: event.notification }),
              );
            } catch (e) {}
          }
        });

      subscribed.current.add(channelName);
    });

    return () => {
      // Leave channels that are no longer relevant
      const current = new Set(projectIds.map((id) => `project.${id}`));
      subscribed.current.forEach((ch) => {
        if (!current.has(ch)) {
          echo.leave(ch);
          subscribed.current.delete(ch);
        }
      });
    };
  }, [projectIds]);
}

export default useNotificationsRealtime;
